import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';

import {GridModule, PageService} from '@syncfusion/ej2-ng-grids';

import {LocatorModule} from '../../widgets/locator/locator.module';
import {MapModule} from '../../widgets/map/map.module';
import {SharedModule} from '../../lib/shared/shared.module';

import {PharmacyLocatorComponent} from './pharmacy-locator.component';

@NgModule({
  imports: [
    HttpClientModule,
    CommonModule,
    FormsModule,
    GridModule,
    LocatorModule,
    MapModule,
    SharedModule
  ],
  declarations: [
    PharmacyLocatorComponent
  ],
  exports: [],
  providers: [PageService]
})
export class PharmacyLocatorModule {

}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/app/pharmacy-locator/pharmacy-locator.module.ts